/* PeakView extras: loads right after peakview-loader.js.
   - Adds the brand-trust image as the 5th gallery slide ("Our brand").
   - Checkout goes through the real Shopify cart, so items added in the chat assistant stay in the order.
   - Shows a checkout pill whenever the Shopify cart has items. */
const PV = window.PV || (window.PV = {});
PV.gallery = (PV.gallery || []).slice(0, 4).concat(["https://cdn.shopify.com/s/files/1/0803/9773/0033/files/hf_20261001_173913_ff48d55f-b3b6-420f-a17a-6afc1a0293bf.png?width=1400"]);
// Checkout goes through the real Shopify cart, so anything the shopper added in the chat stays in the order.
// The goggle bundle picked on the page wins: other bundle sizes are removed, add-ons are set to 1 if ticked.
PV.checkout = async (qty, ids) => {
  const v = PV.variants[String(qty)];
  if (!v) return;
  const items = [v + ":1"];
  const updates = {};
  Object.values(PV.variants).forEach((x) => { updates[x] = x === v ? 1 : 0; });
  (ids || []).forEach((id) => { const a = PV.addons.find((x) => x.id === id); if (a) { items.push(a.variant + ":1"); updates[a.variant] = 1; } });
  try {
    const r = await fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ updates }) });
    if (!r.ok) throw new Error("cart " + r.status);
    window.location.href = "/checkout";
  } catch (e) {
    window.location.href = "/cart/" + items.join(",");
  }
};
// Cart pill: when the Shopify cart has items (for example ones the chat assistant added), show a checkout shortcut.
PV.money = (c) => "$" + (c / 100).toFixed(2);
PV.cartPill = () => {
  let el = null, last = -1;
  const draw = (cart) => {
    const n = (cart && cart.item_count) || 0;
    if (n === last) return; last = n;
    if (!n) { if (el) el.hidden = true; return; }
    if (!el) {
      el = document.createElement("a");
      el.className = "pv-cartpill"; el.href = "/checkout";
      document.body.appendChild(el);
    }
    el.hidden = false;
    el.setAttribute("aria-label", n + (n === 1 ? " item" : " items") + " in your cart, " + PV.money(cart.total_price) + ". Go to checkout");
    el.innerHTML = '<span class="pv-cartpill-n">' + n + '</span><span>' + (n === 1 ? "item" : "items") + " in your cart · " + PV.money(cart.total_price) + '</span><b>Checkout</b>';
  };
  const poll = async () => {
    if (document.visibilityState !== "visible") return;
    try { draw(await (await fetch("/cart.js", { headers: { Accept: "application/json" } })).json()); } catch (e) {}
  };
  poll(); setInterval(poll, 4000);
  document.addEventListener("visibilitychange", poll);
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", PV.cartPill); else PV.cartPill();
